import { render, staticRenderFns } from "./priceformat.vue?vue&type=template&id=6c61155e&"
import script from "./priceformat.vue?vue&type=script&lang=js&"
export * from "./priceformat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c61155e')) {
      api.createRecord('6c61155e', component.options)
    } else {
      api.reload('6c61155e', component.options)
    }
    module.hot.accept("./priceformat.vue?vue&type=template&id=6c61155e&", function () {
      api.rerender('6c61155e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8D6EPAoNB6BUy/JS/priceformat.vue"
export default component.exports